var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-8"},[_c('main-component',{attrs:{"object":_vm.item},on:{"callLoadItem":_vm.loadItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }